
import React from "react";
import {Button, Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {generatePerformanceIndicator, generateBacktest, generateSummary} from "../../data/GenerateRestClient";
import {cleanupData} from "../../data/CleanupRestClient";
import {getAllConfig, getUsedConfig} from "../../data/ReferenceDataRestClient";
import Queue from "promise-queue";

const axios = require('axios');

const MONTHS = ["01","02","03","04","05","06","07","08","09","10","11","12"];
const years = ["2019","2020","2021"];

class Generator extends React.Component {
    constructor(props) {
        super(props);

        let maxConcurrent = 1;
        let maxQueue = 50;
        this.queue = new Queue(maxConcurrent, maxQueue);

        this.defaultValue = props.configValue;

        this.allRequests = [];

        this.state = {
            selectedValue : this.defaultValue == null ? "" : this.defaultValue,
            configList : [],
            indicatorConfigList: [],
            runContext :props.runContext,
            indicatorConfigRows : [],
            configRows:[],
            activeRequests:[],
            newIndicators:[]
        }
        this.parentChangeHandler = props.changedHandler;

        this.requestCounter = 0;
    }


    fetchReferenceData() {
        const activeConfig = getAllConfig();
        const harnessConfig = getUsedConfig("harness");
        const performanceRequest = getUsedConfig("performance");

        axios.all([activeConfig, harnessConfig, performanceRequest]).then(axios.spread((...responses) => {
            this.setState( { "indicatorConfigList" : responses[2].sort(), "configList":responses[1].sort(), "appConfiguration":responses[0]});
            this.populateRows();
        })).catch(errors => {
            console.log("Oops something when wrong.");
        })
    }

    deleteAll(configName, runContxt){
        this.addToQueue(`Delete Data: ${runContxt} - ${configName}`,{
            func : cleanupData,
            configName: configName,
            runContext : runContxt
        }, this.executeDeleteData);

    }

    generateAllBacktest(indcatorConfig){
        for(const year of years){
            this.generateBacktestCall(indcatorConfig, year);
        }
    }

    generateAllPerf(indcatorConfig){
        for(const year of years){
            this.generatePerf(indcatorConfig, year);
        }
    }

    generateBacktestCall(indicatorConfig, year){
        this.addToQueue(`Generate backtest: ${indicatorConfig} - ${year}`,{
            func : generateBacktest,
            year: year,
            indicatorConfig : indicatorConfig
        }, this.executeGenerateData);
    }

    generatePerf(indicatorConfig, year) {
        this.addToQueue(`Generate indicator test: ${indicatorConfig} - ${year}`, {
            func : generatePerformanceIndicator,
            year: year,
            indicatorConfig : indicatorConfig
        },this.executeGenerateData);
    }


    generateSummaryData(runContext) {
        this.addToQueue(`Generate summary`, {func: generateSummary, 'runContext':runContext}, this.executeGenerateSummaryData);
    }

    addDelayPromise (input) {
        return new Promise((resolve, reject) => {
            let wait = Math.floor(Math.random() * 3);
            setTimeout(() => {
                let r = {...input, responseMsg:'Done waiting'}
                resolve(r);
            }, wait * 500);
        })
    }

    addToQueue(title, data, func){
        this.requestCounter++;
        let requestData = {...data, id:this.requestCounter, reqStatus:'running', title:title, responseMsg:"running"}
        this.allRequests.push(requestData);
        this.setState( { "activeRequests" : this.allRequests});
        this.queue.add(() => { return func(requestData)}).then((res)=> {
            this.allRequests.filter(item => {
                    if (item.id === res.id) {
                        item.reqStatus = "done";
                        item.responseMsg = res.responseMsg;
                    }
                    return item;
                });
            this.setState( { "activeRequests" : this.allRequests});
            });
    }

    executeGenerateData(qData) {
        return qData.func(qData.indicatorConfig, qData.year).then(response => {
            return  {...qData, responseMsg: "Executed " + response.executedCount}
        });
    }

    executeGenerateSummaryData(qData) {
        let params = qData;
        return qData.func(params).then(response => {
            return  {...qData, responseMsg: "Summary generated:" + response["lambdas executed"]}
        });
    }

    executeDeleteData(qData) {
        return qData.func(qData.configName, qData.runContext).then(response => {
            return  {...qData, responseMsg: "Data Cleaned " + JSON.stringify(response)}
        });
    }

    populateRows(){
        let indicatorConfigRows =[];
        let configRows = [];
        let newIndicators = [];
        let newConfigRows = [];
        for(let c = 0; c < this.state.indicatorConfigList.length; c++){
            let link = `performance/summary?configName=${this.state.indicatorConfigList[c]}`;
            indicatorConfigRows.push(<Row key={c + "ind"}>
                <Col>{this.state.indicatorConfigList[c]}</Col>
                <Col>Generate:
                <Link to={'#'} onClick={() => this.generatePerf(this.state.indicatorConfigList[c], '2019')}>2019</Link> -
                <Link to={'#'} onClick={() => this.generatePerf(this.state.indicatorConfigList[c], '2020')}>2020</Link> -
                <Link to={'#'} onClick={() => this.generatePerf(this.state.indicatorConfigList[c], '2021')}>2021</Link>
                </Col>
                <Col><Link to={'#'} onClick={() => this.generateAllPerf(this.state.indicatorConfigList[c])}>Generate all</Link></Col>
                <Col><Link to={'#'} onClick={() => this.deleteAll(this.state.indicatorConfigList[c], "performance")}>Delete all</Link></Col>
                <Col><Link to={`${link}`}>Summary</Link></Col>
            </Row>);
        }
        for(let c = 0; c < this.state.appConfiguration.indicatorConfig.length; c++){
            let indiConfig = this.state.appConfiguration.indicatorConfig[c];
            if(!this.state.indicatorConfigList.includes(indiConfig.name)){
                let link = `performance/summary?configName=${this.state.appConfiguration.indicatorConfig[c].name}}`;
                newIndicators.push(<Row key={c + "newind"}>
                    <Col>New Indicator: {this.state.appConfiguration.indicatorConfig[c].name}</Col>
                    <Col>Generate:
                        <Link to={'#'} onClick={() => this.generatePerf(this.state.indicatorConfigList[c], '2019')}>2019</Link> -
                        <Link to={'#'} onClick={() => this.generatePerf(this.state.indicatorConfigList[c], '2020')}>2020</Link> -
                        <Link to={'#'} onClick={() => this.generatePerf(this.state.indicatorConfigList[c], '2021')}>2021</Link>
                    </Col>
                    <Col><Link to={'#'} onClick={() => this.generateAllPerf(this.state.indicatorConfigList[c])}>Generate all</Link></Col>
                    <Col><Link to={`${link}`}>Summary</Link></Col>
                </Row>);
            }
        }
        for(let c = 0; c < this.state.configList.length; c++){
            let link = `harness/summary?configName=${this.state.configList[c]}`;
            configRows.push(<Row key={c+ "conf"}>
                <Col>{this.state.configList[c]}</Col>
                <Col>
                    <Link to={'#'} onClick={() => this.generateBacktest(this.state.configList[c], '2019')}>2019</Link> -
                    <Link to={'#'} onClick={() => this.generateBacktest(this.state.configList[c], '2020')}>2020</Link> -
                    <Link to={'#'} onClick={() => this.generateBacktest(this.state.configList[c], '2021')}>2021</Link>
                </Col>
                <Col><Link to={'#'} onClick={() => this.generateAllBacktest(this.state.configList[c])}>Generate all</Link></Col>
                <Col><Link to={'#'} onClick={() => this.deleteAll(this.state.configList[c], "harness")}>Delete all</Link></Col>
                <Col><Link to={`${link}`}>Summary</Link></Col>
            </Row>);
        }

        for(let c = 0; c < this.state.appConfiguration.fullConfig.length; c++){
            let link = `harness/summary?configName=${this.state.appConfiguration.fullConfig[c].name}`;
            newConfigRows.push(<Row key={c+ "newconf"}>
                <Col>{this.state.appConfiguration.fullConfig[c].name}</Col>
                <Col>
                    <Link to={'#'} onClick={() => this.generateBacktest(this.state.appConfiguration.fullConfig[c].name, '2019')}>2019</Link> -
                    <Link to={'#'} onClick={() => this.generateBacktest(this.state.appConfiguration.fullConfig[c].name, '2020')}>2020</Link> -
                    <Link to={'#'} onClick={() => this.generateBacktest(this.state.appConfiguration.fullConfig[c].name, '2021')}>2021</Link>
                </Col>
                <Col><Link to={'#'} onClick={() => this.generateAllBacktest(this.state.appConfiguration.fullConfig[c].name)}>Generate all</Link></Col>
                <Col><Link to={`${link}`}>Summary</Link></Col>
            </Row>);
        }
        this.setState({"indicatorConfigRows" :indicatorConfigRows, "configRows":configRows, "newIndicators": newIndicators, "newConfig":newConfigRows} );
    }

    componentDidMount() {
        this.fetchReferenceData();
    }

    removeNotification(id){
        this.setState({"activeRequests" :this.state.activeRequests.filter(item => item.id !== id)});
    }
    render() {
        return (
            <Container style={{'margin':'10px 0'}}>
                <Row>
                    <Col>
                        <div className="press-grid">
                        <Container style={{'margin':'10px 0'}} >
                            <Row>
                                <Col><Link to={'#'} onClick={() => this.generateSummaryData('performance')}>Performance Summary</Link></Col>
                            </Row>
                            <Row>
                                <Col><Link to={'#'} onClick={() => this.generateSummaryData('harness')}>Backtest Summary</Link></Col>
                            </Row>
                            <Row>
                                <Col>Indicator Config</Col>
                                <Col>Generate</Col>
                            </Row>
                            {this.state.indicatorConfigRows}
                        </Container>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="press-grid">
                            <Container style={{'margin':'10px 0'}} >
                                <Row>
                                    <Col>Indicator Config</Col>
                                    <Col>Generate</Col>
                                </Row>
                                {this.state.newIndicators}
                            </Container>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="press-grid">
                        <Container style={{'margin':'10px 0'}} >
                            <Row>
                                <Col>Config</Col>
                                <Col>Generate</Col>
                            </Row>
                            {this.state.configRows}
                        </Container>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="press-grid">
                            <Container style={{'margin':'10px 0'}} >
                                <Row>
                                    <Col>New Config</Col>
                                    <Col>Generate</Col>
                                </Row>
                                {this.state.newConfig}
                            </Container>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ul>
                            {this.state.activeRequests.map(item => (
                                <li key={item.id}>
                                    <div>
                                        {item.id} - {item.title} - {item.reqStatus} -
                                        <button type="button" onClick={() => this.removeNotification(item.id)}>
                                            Remove
                                        </button>
                                    </div>
                                    <div>
                                        {item.responseMsg}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </Container>
        )
    };
}
export {Generator}
